import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path className="error" d="M5 12v1h3v-1z" fill="#ef2929" /><path d="M5.469.012c-.49 0-.796.215-1.032.455C4.202.707 4 1.023 4 1.497V2H2v14h8v-2H4V4h2V2.012h4V4h2v3h2V2h-2v-.395l-.002-.027a1.622 1.622 0 00-.416-1.014c-.236-.279-.62-.584-1.2-.552z" style={{
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1,
      marker: "none"
    }} color="#bebebe" fontWeight={400} fontFamily="sans-serif" overflow="visible" fill="#2e3436" /><path d="M12.957 8.002a1 1 0 00-.664.291l-3 3A1 1 0 0010 13h2.104l-.96 1.404a1 1 0 001.524 1.28l3.031-2.97A1 1 0 0015 11h-2.13l.962-1.445a1 1 0 00-.875-1.553z" style={{
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1,
      marker: "none"
    }} color="#bebebe" fontWeight={400} fontFamily="sans-serif" overflow="visible" fill="#2e3436" /><path d="M15 11h1v1h-1zm-6 1h1v1H9zm4-4h1v1h-1zm-2.031 6.968h1v1h-1z" style={{
      marker: "none"
    }} color="#bebebe" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;